module.exports = __webpack_public_path__ + "e071c3887d5a40f65054d411c41baed1.MP3";